import gameInfo from '../assets/json/gameInfo.json'
import Phaser from 'phaser';
import gameData, { LocalizationGameData } from './gameData.js';
import FontKeys from './FontKeys';
import ABCyaLib from '@abcya/abcya_lib';
import ABCyaPhaser from '@abcya/abcya_phaser';

/**
 * To load multiple image sprites, change this property to an array of Phaser.Types.Loader.FileTypes.MultiAtlasFileConfig objects.
 * Ex: ABCyaPhaser.Preloader.PreloaderConfig.imagesPath = [
 * { key: ABCyaPhaser.Images.DEFAULT_ATLAS, atlasURL: 'assets/images/' + ABCyaPhaser.Images.DEFAULT_ATLAS + '.json', path: 'assets/images' }, // default multiatlas
 * { key: "particles", atlasURL: 'assets/images/particles.json', path: 'assets/images' }
 * ]
 */
 ABCyaPhaser.Preloader.PreloaderConfig.imagesPath = [
  { key: ABCyaPhaser.Images.DEFAULT_ATLAS, atlasURL: 'assets/images/htp.json', path: 'assets/images' }, // default multiatlas (with a different json path)
]

/**
 * To load multiple audio sprites, change this property to an array of Phaser.Types.Loader.FileTypes.AudioSpriteFileConfig objects.
 * Note: you should always include an ogg and mp3 file, the game will determine which to use based on compatibility. 
 * Ex: ABCyaPhaser.Preloader.PreloaderConfig.soundsPath = [
 * { key: ABCyaPhaser.Audio.DEFAULT_AUDIO_SPRITE, 
 *   jsonURL: 'assets/sounds/' + DEFAULT_AUDIO_SPRITE + '.json', 
 *   audioURL: [ 'assets/sounds/' + DEFAULT_AUDIO_SPRITE + '.ogg', 'assets/sounds/' + DEFAULT_AUDIO_SPRITE + '.mp3' ] }, // default sound sprite
 * { key: "extrasounds", jsonURL: 'assets/sounds/extrasounds.json', audioURL: [ 'assets/sounds/extrasounds.ogg', 'assets/sounds/extrasounds.mp3' ] }
 * ]
 */
ABCyaPhaser.Preloader.PreloaderConfig.soundsPath = 'assets/sounds';
/**
 * You can load spine objects here. This can be an object with key, jsonPath, and atlasPath properties, or an array of those objects.
 * Ex: ABCyaPhaser.Preloader.PreloaderConfig.spines = [
 * { key: "spine0", jsonPath: "assets/spines/spine0.json", atlasPath: "assets/spines/spine0.atlas" },
 * { key: "spine1", jsonPath: "assets/spines/spine1.json", atlasPath: "assets/spines/spine1.atlas" }
 * ]
 */
//ABCyaPhaser.Preloader.PreloaderConfig.spines = { key: "", jsonPath: "", atlasPath: "" };

ABCyaPhaser.Preloader.PreloaderConfig.startScene = gameData.startScene;

/**
 * Called when the preload function is done.
 * @param {Phaser.Scene} scene the preloader scene
 */
ABCyaPhaser.Preloader.PreloaderConfig.preloadCallback = scene =>
{
    const loadBitmapFont = function (key, location)
    {
        scene.load.bitmapFont(key, location + '/' + key + '.png', location + '/' + key + '.fnt');
    }
    // load the bitmap fonts
    loadBitmapFont('comfortaa', 'assets/fonts');
    loadBitmapFont('Carton_Six', 'assets/fonts');
    loadBitmapFont('comfortaa_b', 'assets/fonts');
    loadBitmapFont('hansief', 'assets/fonts');
}

(async function handshake()
{
    try
    {
        await ABCyaLib.Environment.instance.doParentHandshake();
    } catch (error)
    {
        console.warn(error);
    }

    console.info("ABCya Game Info:", gameInfo);

    // someday might turn this on, which allows the preloader to progress automatically to the game when in the native game app
    //ABCyaPhaser.Preloader.PreloaderConfig.proceedImmediately = ABCyaLib.Environment.instance.platformType == ABCyaLib.Environment.PLATFORM_TYPES.native;

    /**
     * Use the fourth argument of initializePhaserGame to override default Phaser config options
     * For example: to use the Spine plugin, the fourth argument should look like this:
     * { 
            configOverrides: {
                plugins: {
                    scene: [
                        { key: 'SpinePlugin', plugin: window.SpinePlugin, mapping: 'spine' }
                    ]
                }
            }
        }
     */
    switch(ABCyaLib.Environment.instance.locale)
    {
      case 'en-AU':
        gameData.right = [...gameData.right, ...LocalizationGameData['en-AU'].right];
        gameData.groups[0] = [...gameData.groups[0], ...LocalizationGameData['en-GB_CA_AU'].groups[0], ...LocalizationGameData['en-GB_AU'].groups[0], ...LocalizationGameData['en-AU'].groups[0]];
        gameData.groups[1] = [...gameData.groups[1], ...LocalizationGameData['en-GB_CA_AU'].groups[1], ...LocalizationGameData['en-GB_AU'].groups[1], ...LocalizationGameData['en-AU'].groups[1]];
        gameData.groups[2] = [...gameData.groups[2], ...LocalizationGameData['en-GB_CA_AU'].groups[2], ...LocalizationGameData['en-GB_AU'].groups[2], ...LocalizationGameData['en-AU'].groups[2]];
        gameData.groups[3] = [...gameData.groups[3], ...LocalizationGameData['en-GB_CA_AU'].groups[3], ...LocalizationGameData['en-GB_AU'].groups[3], ...LocalizationGameData['en-AU'].groups[3]];
        gameData.groups[4] = [...gameData.groups[4], ...LocalizationGameData['en-GB_CA_AU'].groups[4], ...LocalizationGameData['en-GB_AU'].groups[4], ...LocalizationGameData['en-AU'].groups[4]];
        break;
      case 'en-GB':
        gameData.right = [...gameData.right, ...LocalizationGameData['en-GB'].right];
        gameData.groups[0] = [...gameData.groups[0], ...LocalizationGameData['en-GB_CA_AU'].groups[0], ...LocalizationGameData['en-GB_AU'].groups[0], ...LocalizationGameData['en-GB'].groups[0]];
        gameData.groups[1] = [...gameData.groups[1], ...LocalizationGameData['en-GB_CA_AU'].groups[1], ...LocalizationGameData['en-GB_AU'].groups[1], ...LocalizationGameData['en-GB'].groups[1]];
        gameData.groups[2] = [...gameData.groups[2], ...LocalizationGameData['en-GB_CA_AU'].groups[2], ...LocalizationGameData['en-GB_AU'].groups[2], ...LocalizationGameData['en-GB'].groups[2]];
        gameData.groups[3] = [...gameData.groups[3], ...LocalizationGameData['en-GB_CA_AU'].groups[3], ...LocalizationGameData['en-GB_AU'].groups[3], ...LocalizationGameData['en-GB'].groups[3]];
        gameData.groups[4] = [...gameData.groups[4], ...LocalizationGameData['en-GB_CA_AU'].groups[4], ...LocalizationGameData['en-GB_AU'].groups[4], ...LocalizationGameData['en-GB'].groups[4]];
        break;
      case 'en-CA':
        gameData.right = [...gameData.right, ...LocalizationGameData['en-CA'].right];
        gameData.groups[0] = [...gameData.groups[0], ...LocalizationGameData['en-GB_CA_AU'].groups[0], ...LocalizationGameData['en-CA'].groups[0], ...LocalizationGameData['en-CA_US'].groups[0]];
        gameData.groups[1] = [...gameData.groups[1], ...LocalizationGameData['en-GB_CA_AU'].groups[1], ...LocalizationGameData['en-CA'].groups[1], ...LocalizationGameData['en-CA_US'].groups[1]];
        gameData.groups[2] = [...gameData.groups[2], ...LocalizationGameData['en-GB_CA_AU'].groups[2], ...LocalizationGameData['en-CA'].groups[2], ...LocalizationGameData['en-CA_US'].groups[2]];
        gameData.groups[3] = [...gameData.groups[3], ...LocalizationGameData['en-GB_CA_AU'].groups[3], ...LocalizationGameData['en-CA'].groups[3], ...LocalizationGameData['en-CA_US'].groups[3]];
        gameData.groups[4] = [...gameData.groups[4], ...LocalizationGameData['en-GB_CA_AU'].groups[4], ...LocalizationGameData['en-CA'].groups[4], ...LocalizationGameData['en-CA_US'].groups[4]];
        break;
      default:
        gameData.right = [...gameData.right, ...LocalizationGameData['en-US'].right];
        gameData.groups[0] = [...gameData.groups[0], ...LocalizationGameData['en-US'].groups[0], ...LocalizationGameData['en-CA_US'].groups[0]];
        gameData.groups[1] = [...gameData.groups[1], ...LocalizationGameData['en-US'].groups[1], ...LocalizationGameData['en-CA_US'].groups[1]];
        gameData.groups[2] = [...gameData.groups[2], ...LocalizationGameData['en-US'].groups[2], ...LocalizationGameData['en-CA_US'].groups[2]];
        gameData.groups[3] = [...gameData.groups[3], ...LocalizationGameData['en-US'].groups[3], ...LocalizationGameData['en-CA_US'].groups[3]];
        gameData.groups[4] = [...gameData.groups[4], ...LocalizationGameData['en-US'].groups[4], ...LocalizationGameData['en-CA_US'].groups[4]];
        break;
    }

    console.log(gameData.right);
    console.log(gameData.groups);

    ABCyaPhaser.Misc.initializePhaserGame(768, 1024, gameData.scenes);

    // initialize any functionality in abcya_phaser that has a dependency on abcya_lib 
    ABCyaPhaser.Misc.initializeAbcyaLibDependencies(ABCyaLib);
})();
